module.exports = __webpack_public_path__ + "img/naturalius1C769D.255030eb.png";